import { objectLookup } from "@madhive/mad-sdk";
import { useMemo } from "react";
import { madSDK } from "../sdk";
class InvalidCollection extends Error {
    /**
     * @param collection: the offending collection name.
     */
    constructor(collection) {
        super();
        if (Error?.captureStackTrace) {
            Error.captureStackTrace(this, InvalidCollection);
        }
        this.name = "InvalidCollection";
        this.message = `No SDK collection with the name '${collection}' exists.`;
    }
}
/**
 * Gets a handler from the MadSDK for a given collection path.
 * @param collection - The collection path or nested handler
 * @returns The handler for the specified collection
 * @throws {InvalidCollection} If the collection doesn't exist in the SDK
 */
export const getHandler = (collection) => {
    if (typeof collection !== "string") {
        return collection;
    }
    const handler = objectLookup(madSDK, collection);
    if (!handler) {
        throw new InvalidCollection(`${collection}`);
    }
    return handler;
};
/**
 * Hook that returns a MadSDK handler for a given collection path.
 * This is a memoized wrapper around getHandler that ensures the handler reference
 * remains stable across re-renders.
 *
 * @param collection - The collection path (e.g., "campaigns", "advertisers") or nested handler
 * @returns The handler for the specified collection
 * @throws {InvalidCollection} If the collection doesn't exist in the SDK
 *
 * @example
 * ```tsx
 * const campaignsHandler = useCollection("campaigns");
 * const advertiserHandler = useCollection("advertisers");
 * ```
 */
export const useCollection = (collection) => useMemo(() => getHandler(collection), [collection]);
//# sourceMappingURL=collections.js.map